// extracted by mini-css-extract-plugin
export default {"galleryItem":"c-n_fA","galleryItem_borderTopRadius":"c-n_fB","galleryItem__image":"c-n_fC","galleryItem__image_withBlur":"c-n_fE"};